<div class="all-spending-box bg-white">
    <h5 class="fw-medium">
        All Spending
    </h5>
    <div class="info position-relative">
        <div class="chart">
            <img src="assets/images/icons/area.svg" alt="chart">
        </div>
        <h6 class="fw-medium">
            $12,095
        </h6>
        <span class="d-inline-block text-gray">
            Expenses
        </span>
    </div>
</div>